import React, { Fragment, useState, Component, useRef, useEffect} from "react"

import { accessRole } from "../../../../../helpers/access_role"
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Input
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import { AvField, AvForm} from "availity-reactstrap-validation"

import apiResponse from '../../../../../services/apiResponse'

import DetailPegawaiBloc from './Blocs/DetailPegawaiBloc'
import Tabledetailpresensi from './Components/TableDetailPegawaiComponent'

const IndexView = (props) => {

    const [periode, setPeriode] = useState({ start: '', end: '' })
    const [params, setParams] = useState([])

    const activeRef = useRef();

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'))
    const peg_detail = !accessRole('approve') ? (userdata != null ? userdata : "") 
    : (employeeSeleted != null ? employeeSeleted : "")




    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                        <CardTitle>Detail Kehadiran Tanpa Keterangan</CardTitle>
                        <CardSubtitle className="mb-1">
                            Informasi Detail Kehadiran Tanpa Keterangan
                        </CardSubtitle>
                        <hr />             
                        <Row className="mb-1">
                            <label className="col-md-3">
                                NIP
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_nip
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Nama
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_name
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Jabatan
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_current_position_name
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Unit Kerja
                            </label>
                            <Col md="9">
                                {
                                    peg_detail.employee_current_work_unit_name
                                }
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Periode Mulai
                            </label>
                            <Col md="3">
                                <Input
                                    name="start_period"
                                    placeholder="Periode Mulai..."
                                    type="date"
                                    errorMessage="Masukkan Periode Mulai"
                                    className="form-control"
                                    id="start_period"
                                    onChange={event => setPeriode({...periode, start: event.target.value })}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <label className="col-md-3">
                                Periode Akhir
                            </label>
                            <Col md="3">
                                <Input
                                    name="end_period"
                                    placeholder="Periode Akhir..."
                                    type="date"
                                    errorMessage="Masukkan Periode Akhir"
                                    className="form-control"
                                    id="end_period"
                                    onChange={event => setPeriode({...periode, end: event.target.value })}
                                />
                            </Col>
                        </Row>
                        <Row className="mb-1">
                            <Col md="3"></Col>
                            <Col md="6">
                                <Button 
                                    color="primary" 
                                    type="button"
                                    onClick={() => {
                                        setParams(periode)
                                    }}
                                >
                                    <i className="uil-search-alt"></i> Cari
                                </Button>
                                {' '}
                                <Button 
                                    color="warning" 
                                    type="button"
                                    onClick={() => {
                                        setParams([])
                                        setPeriode({ start: '', end: '' })
                                    }}
                                    >
                                    <i className="uil-refresh"></i> Reset
                                </Button>
                            </Col>
                        </Row>
                        <hr/>
                        <Tabledetailpresensi uuid={peg_detail.employee_uuid} params={params} />
                    </CardBody>
                </Card>

            </Container>
        </Fragment>
    )
}

export default IndexView